import { capitalize } from '../../../../utils/string';
import { DropdownOption } from './DropdownOption';
import { DropdownOptionsGroup } from './DropdownOptionsGroup';

export class DropdownOptionsGroups<Value = number, Name extends string = string> {
  public readonly list: Array<DropdownOptionsGroup<Value, Name>>;
  public readonly label: string;
  public readonly allSelectedLabel: string;

  private flattenOptionsList: DropdownOption<Value>[] | null = null;

  public constructor(list: Array<DropdownOptionsGroup<Value, Name>>, label: string, allSelectedLabel = 'Все типы') {
    this.list = list;
    this.label = label;
    this.allSelectedLabel = allSelectedLabel;
  }

  public getLabel(values: Array<Value>): string {
    const flattenList = this.getFlattenOptionsList();

    if (!flattenList.length) {
      return this.label;
    }

    const isEveryValuesIncluded = flattenList.every(item => item.checkIsActive(values));

    if (isEveryValuesIncluded) {
      return this.allSelectedLabel;
    }

    const shortLabelsList = flattenList.reduce((accumulator, item) => {
      if (item.checkIsActive(values)) {
        accumulator.push(item.shortLabel.toLowerCase());
      }

      return accumulator;
    }, Array.of<string>());

    if (shortLabelsList.length) {
      return capitalize(shortLabelsList.join(', '));
    }

    return this.label;
  }

  public getAllGroupsAreEmpty(): boolean {
    return !this.getFlattenOptionsList().length;
  }

  private getFlattenOptionsList(): DropdownOption<Value>[] {
    if (!this.flattenOptionsList) {
      this.flattenOptionsList = this.list.flatMap(item => item.list);
    }

    return this.flattenOptionsList;
  }
}
